"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXTERNAL_ROLES = exports.INTERNAL_ROLES = exports.DESCRIBED_ROLES = exports.Roles = void 0;
var Roles;
(function (Roles) {
    /**
     * External role, a.k.a. Exams Officer
     */
    Roles["SUBMIT_EXAMS_OFFICER"] = "SUBMIT_EXAMS_OFFICER";
    /**
     * External role, a.k.a. Teacher
     */
    Roles["SUBMIT_TEACHER"] = "SUBMIT_TEACHER";
    /**
     * External role, a.k.a. Delegated admin
     */
    Roles["DELEGATED_ADMIN"] = "DELEGATED_ADMIN";
    /**
     * Internal role, a.k.a. Moderator
     */
    Roles["SUBMIT_MODERATOR"] = "SUBMIT_MODERATOR";
    /**
     * Internal role, a.k.a. Internal Moderator
     */
    Roles["SUBMIT_INTERNAL_MODERATOR"] = "SUBMIT_INTERNAL_MODERATOR";
    /**
     * Internal role, a.k.a. ASP and Marking Administrator
     */
    Roles["SUBMIT_ADMINISTRATOR"] = "SUBMIT_ADMINISTRATOR";
    /**
     * Internal role, a.k.a. Super Administrator
     */
    Roles["SUBMIT_SUPER_ADMIN"] = "SUBMIT_SUPER_ADMIN";
    /**
     * Internal role, a.k.a. Compliance Officer
     */
    Roles["SUBMIT_COMPLIANCE"] = "SUBMIT_COMPLIANCE";
    /**
     * Internal role, a.k.a. Assessment Manager
     */
    Roles["SUBMIT_INTERNAL_ASSESSMENT_MANAGER"] = "SUBMIT_INTERNAL_ASSESSMENT_MANAGER";
    /**
     * Internal role, a.k.a. Customer Services Advisor
     */
    Roles["SUBMIT_HELPDESK"] = "SUBMIT_HELPDESK";
})(Roles = exports.Roles || (exports.Roles = {}));
exports.DESCRIBED_ROLES = {
    [Roles.SUBMIT_EXAMS_OFFICER]: {
        name: Roles.SUBMIT_EXAMS_OFFICER,
        description: 'Exams Officer',
    },
    [Roles.SUBMIT_TEACHER]: {
        name: Roles.SUBMIT_TEACHER,
        description: 'Teacher',
    },
    [Roles.DELEGATED_ADMIN]: {
        name: Roles.DELEGATED_ADMIN,
        description: 'Delegated admin',
    },
    [Roles.SUBMIT_MODERATOR]: {
        name: Roles.SUBMIT_MODERATOR,
        description: 'Moderator',
    },
    [Roles.SUBMIT_INTERNAL_MODERATOR]: {
        name: Roles.SUBMIT_INTERNAL_MODERATOR,
        description: 'Internal Moderator',
    },
    [Roles.SUBMIT_ADMINISTRATOR]: {
        name: Roles.SUBMIT_ADMINISTRATOR,
        description: 'ASP and Marking Administrator',
    },
    [Roles.SUBMIT_SUPER_ADMIN]: {
        name: Roles.SUBMIT_SUPER_ADMIN,
        description: 'Super Administrator',
    },
    [Roles.SUBMIT_COMPLIANCE]: {
        name: Roles.SUBMIT_COMPLIANCE,
        description: 'Compliance Officer',
    },
    [Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER]: {
        name: Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER,
        description: 'Assessment Manager',
    },
    [Roles.SUBMIT_HELPDESK]: {
        name: Roles.SUBMIT_HELPDESK,
        description: 'Customer Services Advisor',
    },
};
exports.INTERNAL_ROLES = [
    Roles.SUBMIT_SUPER_ADMIN,
    Roles.SUBMIT_ADMINISTRATOR,
    Roles.SUBMIT_COMPLIANCE,
    Roles.SUBMIT_HELPDESK,
    Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER,
];
exports.EXTERNAL_ROLES = [
    Roles.SUBMIT_EXAMS_OFFICER,
    Roles.SUBMIT_MODERATOR,
    Roles.SUBMIT_TEACHER,
    Roles.SUBMIT_INTERNAL_MODERATOR,
    Roles.DELEGATED_ADMIN,
];
